<template>
  <!-- 书籍 -->
  <div class="letter" v-wechat-title="$route.meta.title">
    <!-- 商品详情标题 -->
    <van-nav-bar title="第三方标题栏">
      <!-- <template #right>
        <van-icon name="search" size="18" />
      </template>-->
    </van-nav-bar>
    <!-- 书籍封面/标题 -->
    <div class="cover">
      <div class="cover_img">
        <img :src="Datalist.coverMsg" alt />
      </div>
      <div class="cover_title">
        <h1>{{Datalist.bookName}}</h1>
        <span>{{Datalist.appName}}</span>
      </div>
    </div>
    <!-- 书籍相关内容 -->
    <div class="letter_content">
      <div class="letter_content_list">
        <span class="letter_content_left">类别</span>
        <span>{{Datalist.categoryName}}</span>
      </div>
      <div class="letter_content_list">
        <span class="letter_content_left">年代</span>
        <span>{{Datalist.chronologyName}}</span>
      </div>
      <div class="letter_content_list">
        <span class="letter_content_left">派别</span>
        <span>{{Datalist.factionName}}</span>
      </div>
      <p>
        {{Datalist.content}}
      </p>
    </div>
    <!-- app下载 -->
    <div class="eclipse">
      <!-- logo/名称 -->
      <div class="eclipse_left">
        <div class="eclipse_img">
          <img :src="Datalist.appLogoPath" alt />
        </div>
        <div>图书馆</div>
      </div>
      <!-- 下载app -->
       <a href="http://my.cdsxlc.cn:8095/pak/mahashri.pak">
      <div class="eclipse_right">下载APP</div>
      </a>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data() {
    return {
      Datalist:'',
      idcode:null
    };
  },
  mounted () {
     //获取id
     let herdid =  location.pathname.split('/')
    this.idcode = herdid[herdid.length-1]
    this.letterDate(this.idcode)
  
  },
  methods: {
    letterDate(id) {
      this.$apicode
        .letterData(id)
        .then(res => {
          // console.log(res);
          this.Datalist = res.data
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style lang="less" scoped>
.letter {
  height: 100vh;
  .cover {
    display: flex;
    padding: 0.625rem;
    .cover_img {
      width: 6.25rem;
      height: 8.75rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .cover_title {
      margin-left: 0.625rem;
      h1 {
        caret-color: #666;
        font-weight: 400;
        font-size: 1.125rem;
        margin: 0.3125rem 0;
      }
    }
  }
  .letter_content {
    padding: 0.625rem;
    .letter_content_list {
      margin: 0.9375rem 0;
      color: #333;
      .letter_content_left {
        color: #999;
        margin-right: 1.875rem;
      }
    }
    p {
      color: #333;
    }
  }
  .eclipse {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    bottom: 0rem;
    left: 0rem;
    width: 100%;
    height: 3.125rem;
    color: #333;
    border-top: 0.0625rem solid #f8f9fa;
    .eclipse_left {
      display: flex;
      align-items: center;
      margin-left: 0.625rem;
      .eclipse_img {
        width: 2.5rem;
        height: 2.5rem;
        background-color: #00f;
        border-radius: 0.25rem;
        margin-right: 0.625rem;
        img {
          border-radius: 0.25rem;
        }
      }
    }
    .eclipse_right {
      border: 0.0625rem solid #666;
      margin-right: 0.625rem;
      height: 2rem;
      line-height: 2rem;
      width: 4.375rem;
      text-align: center;
      border-radius: 2.5rem;
      font-size: 0.9375rem;
      color: #666;
    }
  }
}
</style>